/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ExportCashflowReportRequest,
  ExportInvoiceRequest,
  ExportInvoicesRequest,
  ExportPayoutReportRequest,
  ExportUnpaidCompletedWorkReportRequest,
  ReportExportDto
} from '.././types';




  /**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const exportInvoice = <TData = AxiosResponse<ReportExportDto>>(
    exportInvoiceRequest: ExportInvoiceRequest, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/export-invoice`,
      exportInvoiceRequest,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const exportInvoices = <TData = AxiosResponse<ReportExportDto>>(
    exportInvoicesRequest: ExportInvoicesRequest, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/export-invoices`,
      exportInvoicesRequest,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getInvoiceExportById = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/invoice-exports/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const markInvoiceExportDownloaded = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/invoice-exports/${id}/mark-downloaded`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const retryInvoiceExport = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/invoice-exports/${id}/retry`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const exportPayoutReport = <TData = AxiosResponse<ReportExportDto>>(
    exportPayoutReportRequest: ExportPayoutReportRequest, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/export-payout-report`,
      exportPayoutReportRequest,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getPayoutReportExportById = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/payout-report-exports/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const markPayoutReportExportDownloaded = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-report-exports/${id}/mark-downloaded`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const retryPayoutReportExport = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/payout-report-exports/${id}/retry`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const exportUnpaidCompletedWorkReport = <TData = AxiosResponse<ReportExportDto>>(
    exportUnpaidCompletedWorkReportRequest: ExportUnpaidCompletedWorkReportRequest, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/export-unpaid-completed-work-report`,
      exportUnpaidCompletedWorkReportRequest,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getUnpaidCompletedWorkReportExportById = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/unpaid-completed-work-report-exports/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const markUnpaidCompletedWorkReportExportDownloaded = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/unpaid-completed-work-report-exports/${id}/mark-downloaded`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const retryUnpaidCompletedWorkReportExport = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/unpaid-completed-work-report-exports/${id}/retry`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const exportCashflowReport = <TData = AxiosResponse<ReportExportDto>>(
    exportCashflowReportRequest: ExportCashflowReportRequest, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/export-cashflow-report`,
      exportCashflowReportRequest,options
    );
  }
/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const getCashflowReportExportById = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/cashflow-report-exports/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const markCashflowReportExportDownloaded = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/cashflow-report-exports/${id}/mark-downloaded`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_FUNDING_GET
 */
export const retryCashflowReportExport = <TData = AxiosResponse<ReportExportDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/cashflow-report-exports/${id}/retry`,undefined,options
    );
  }
export type ExportInvoiceResult = AxiosResponse<ReportExportDto>
export type ExportInvoicesResult = AxiosResponse<ReportExportDto>
export type GetInvoiceExportByIdResult = AxiosResponse<ReportExportDto>
export type MarkInvoiceExportDownloadedResult = AxiosResponse<void>
export type RetryInvoiceExportResult = AxiosResponse<ReportExportDto>
export type ExportPayoutReportResult = AxiosResponse<ReportExportDto>
export type GetPayoutReportExportByIdResult = AxiosResponse<ReportExportDto>
export type MarkPayoutReportExportDownloadedResult = AxiosResponse<void>
export type RetryPayoutReportExportResult = AxiosResponse<ReportExportDto>
export type ExportUnpaidCompletedWorkReportResult = AxiosResponse<ReportExportDto>
export type GetUnpaidCompletedWorkReportExportByIdResult = AxiosResponse<ReportExportDto>
export type MarkUnpaidCompletedWorkReportExportDownloadedResult = AxiosResponse<void>
export type RetryUnpaidCompletedWorkReportExportResult = AxiosResponse<ReportExportDto>
export type ExportCashflowReportResult = AxiosResponse<ReportExportDto>
export type GetCashflowReportExportByIdResult = AxiosResponse<ReportExportDto>
export type MarkCashflowReportExportDownloadedResult = AxiosResponse<void>
export type RetryCashflowReportExportResult = AxiosResponse<ReportExportDto>
